import { useState } from 'react';

import {
  Button,
  ButtonDialog,
  DialogLayout,
} from '@autopass-web/mochi-component';

import { ENV_CONFIG } from '../../config';
import styles from './marketing-email-opted-in-dialog.module.scss';

interface CustomerServiceModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onClose: () => void;
}

export const OptedInDesc = () => {
  const [isShow, setIsShow] = useState(false);
  return (
    <>
      <Modal isShow={isShow} setIsShow={setIsShow} />
      <div className={styles['content']}>
        同意車麻吉使用我的電子郵件，以寄送行銷活動、會員優惠與最新資訊。您可隨時於信件中取消訂閱。
        （
        <span
          className={styles['action']}
          onClick={() => {
            setIsShow(true);
          }}
        >
          直接行銷同意條款
        </span>
        ）
      </div>
    </>
  );
};

const Modal = ({
  isShow,
  setIsShow,
}: {
  isShow: boolean;
  setIsShow: (boolean) => void;
}) => {
  return (
    <DialogLayout
      className={styles.modal}
      contentClassName={'dialog-content'}
      show={isShow}
    >
      <div className={styles['iframe']}>
        <iframe
          title={'marketingConsent'}
          src={ENV_CONFIG.MARKETING_CONSENT_LINK}
          id="marketingConsent"
        />
      </div>
      <div className={styles.actions}>
        <Button
          onClick={() => {
            setIsShow(false);
          }}
        >
          關閉
        </Button>
      </div>
    </DialogLayout>
  );
};

export const MarketingEmailOptedInDialog = ({
  isOpen,
  onAccept,
  onClose,
}: CustomerServiceModalProps) => (
  <ButtonDialog
    show={isOpen}
    title="同意直接行銷信件"
    message={<OptedInDesc />}
    buttonList={[
      {
        theme: 'positive',
        content: '同意',
        onClick: onAccept,
      },
      {
        theme: 'cancel',
        content: '取消',
        onClick: onClose,
      },
    ]}
  />
);
